<template>
  <v-list two-line>
    <template v-for="(event, index) in events">
      <v-list-tile :key="event.name + index" avatar ripple @click="downloadTickets(event)">
        <v-list-tile-content>
          <v-list-tile-title>{{ event.name }}</v-list-tile-title>
          <v-list-tile-sub-title class="text--primary">{{ event.date_start }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="index + 1 < events.length" :key="index"></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('setEventsList', this.$store.getters.userId)
    this.$store.dispatch('setCurrentPage', 'Eventos')
  },
  computed: {
    events() {
      return this.$store.getters.eventsList
    }
  },
  methods: {
    downloadTickets(event) {
      this.$store.dispatch('setSelectedEvent', event)
      this.$store.dispatch('setProductsList', event.id)
      this.$store.dispatch('setEventTickets', event.id)
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/events/EventsList.vue